import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export const UPDATE_TABLE_STRUCTURE = "getWAVELOGSTableStructure";
export const UPDATE_TABLE_DATA = "getWAVELOGSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setWAVELOGSTableStructure";
export const SET_TABLE_DATA = "setWAVELOGSTableData";
export const SET_TABLE_FILTER = "setWAVELOGSTableFilter";
export const SET_TABLE_PAGE = "setWAVELOGSTablePage";
export const SET_TABLE_PERPAGE = "setWAVELOGSTablePerPage";
export const SET_TABLE_SORTBY = "setWAVELOGSTableSortBy";

const state = {
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getWAVELOGSTableProperties(state) {
    return state.table_structure.properties;
  },
  getWAVELOGSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getWAVELOGSTableState(state) {
    return state.table_state;
  },

  getWAVELOGSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getWAVELOGSTableFilters(state) {
    return state.table_structure.filters;
  },

  getWAVELOGSTableData(state) {
    return state.table_data.data;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/warehouse_management/wave_logs")
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post("/warehouse_management/wave_logs/datatable", {
        ...payload,
        warehouse_id: context.getters.getSelectedWarehouse,
      })
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
